import { useContext, useEffect, createContext, useState } from 'react';
import { settingsAPI } from '../api';
import { useMondayContext } from './monday-context';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const { sessionToken } = useMondayContext();

  useEffect(() => {
    let isSubscribed = true;
    const getSettings = async () => {
      try {
        const { settings: fetchedSettings } = await settingsAPI.getSettings(sessionToken);
        if (!isSubscribed) return;
        setSettings(fetchedSettings);
      } catch {}
    };

    sessionToken && getSettings();

    return () => (isSubscribed = false);
  }, [sessionToken]);

  return <SettingsContext.Provider value={{ settings, setSettings }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => {
  return useContext(SettingsContext);
};
